module.exports = __webpack_public_path__ + "images/accents/accent-box-presenter-055d628c75e12fc1b50d4b2b8d08bb80.webp";